/* src/app/pages/detalle-inmueble/detalle-inmueble.component.css */
.spinner-row {
  margin: 35px 0px;
}
.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100px;
}
.spinner-container img {
  width: 100px;
  height: 100px;
}
.detalle-view {
  display: block;
  justify-content: center;
  padding: 40px 58px;
}
@media (max-width: 473.5px) {
  .detalle-view {
    padding: 40px 16px;
  }
}
.error-block {
  margin: auto;
  max-width: 1324px;
  width: 100%;
}
.titulo-error {
  text-align: center;
  color: #323E48;
  font-family: "Gotham Medium";
  font-size: 20px;
  line-height: 23px;
}
.detalle-layout {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 45px;
  height: auto;
  margin-bottom: 5em;
}
@media (max-width: 1050px) {
  .detalle-layout {
    display: flex;
    flex-direction: column;
    gap: 45px;
    height: fit-content;
    margin-bottom: 40px;
  }
}
.imagen-principal {
  margin-bottom: 13px;
  width: 100%;
}
.img-principal {
  max-width: 634px;
  width: 100%;
  height: auto;
}
.imagenes-slide {
  display: flex;
  justify-content: center;
  gap: 17px;
  width: 100%;
  padding: 0;
}
.miniatura img {
  width: 200px;
  height: 150px;
  object-fit: cover;
}
.carousel-item {
  width: 100%;
}
.carousel-inner {
  width: 100%;
}
.carousel-controles {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 64px;
  height: 45px;
  margin-top: 10px;
}
.custom-arrow {
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
}
.custom-arrow img {
  width: 22px;
  height: 22px;
}
.carousel-indicators-custom {
  display: flex;
  gap: 14px;
}
.carousel-indicators-custom button {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: none;
  background-color: #A2A9AD;
  cursor: pointer;
  padding: 0;
  box-sizing: content-box;
}
.carousel-indicators-custom .active {
  background-color: #BD001F;
  width: 24px;
  height: 8px;
  border-radius: 7px;
}
.carousel-indicators.carousel-indicators-custom {
  position: static !important;
  margin: 0;
}
.galeria-inmueble {
  max-width: 634px;
  width: 100%;
  height: auto;
}
.info-inmueble {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  max-width: 645px;
  text-align: left;
  display: flex;
  flex-direction: column;
}
.inmueble-datos {
  margin-bottom: 113px;
  max-width: 577px;
}
.inmueble-inf {
  display: block;
}
.descripcion-block {
  margin-bottom: 10px;
}
.info-title {
  font-family: "Gotham Bold";
  font-size: 20px;
  line-height: 23px;
  color: #323E48;
  margin-bottom: 10px;
}
.folio-label {
  font-family: "Gotham Medium";
  color: #5B6670;
  font-size: 15px;
  line-height: 20px;
  margin-bottom: 43px;
}
.medium-label {
  font-family: "Gotham Medium";
  color: #5B6670;
  font-size: 15px;
  line-height: 20px;
  margin: 0;
}
.book-label {
  font-family: "Gotham Book";
  color: #5B6670;
  font-size: 15px;
  line-height: 20px;
  margin-bottom: 5px;
}
.book-label:last-child {
  margin-bottom: 0;
}
.price-label {
  font-family: "Gotham Medium";
  color: #323E48;
  font-size: 25px;
  line-height: 25px;
  margin-bottom: 20px;
}
.btns {
  margin-top: auto;
  justify-content: left;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}
.btn-detalle {
  font-family: "Gotham Medium";
  font-size: 15px;
  line-height: 100%;
  color: #EB0029;
  gap: 20px;
  display: flex;
  align-items: center;
  padding: 16px 30px;
}
.map-container {
  margin: auto;
  height: 494px;
  max-width: 1324px;
  width: 100%;
}
.titulo-mapa {
  font-family: "Gotham Bold";
  font-size: 25px;
  line-height: 30px;
  color: #323E48;
  align-self: flex-start;
  margin: 0 0 40px 0;
  padding: 0;
}
.close-button {
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
}
.close-button img {
  width: 100%;
  height: 100%;
  display: block;
}
.close-button:focus,
.close-button:focus-visible {
  outline: none;
  box-shadow: none;
}
.modal-subtitle {
  font-family: "Gotham Medium";
  font-size: 20px;
  line-height: 25px;
  color: #323E48;
  margin-top: 0;
  margin-bottom: 0px;
}
.modal-text {
  font-family: "Gotham Book";
  font-size: 15px;
  line-height: 20px;
  color: #5B6670;
  margin: 25px 0px;
}
.compartir-icono {
  width: 50px;
  height: 50px;
  margin-top: 51px;
  margin-bottom: 19.5px;
}
.modal-button {
  width: 150px;
  height: 45px;
  background-color: #FFFFFF;
  font-size: 15px;
  line-height: 18px;
  font-family: "Gotham Medium";
  color: #323E48;
  border-radius: 4px;
  border: 1px solid #323E48;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  text-decoration: none;
}
.modal-button:hover,
.modal-button:active {
  color: #EB0029;
  border-color: #EB0029;
  background-color: white !important;
  box-shadow: none !important;
}
.icon-img {
  width: 24px;
  height: 24px;
}
.buttons-row {
  gap: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 40px;
}
#shareModal .modal-dialog {
  max-width: 720px;
  width: auto;
}
#shareModal .modal-content {
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
}
.modal-button:hover .whatsapp-icon,
.modal-button:active .whatsapp-icon {
  content: url(/banorte/__host/inmuebles/Inmuebles/assets/iconos/icono_whatsapp.svg);
  width: 24px;
  height: 24px;
}
.modal-button:hover .correo-icon,
.modal-button:active .correo-icon {
  content: url(/banorte/__host/inmuebles/Inmuebles/assets/iconos/icono_correo.svg);
  width: 24px;
  height: 24px;
}
#recomendarModal .modal-dialog {
  max-width: 720px;
  width: auto;
}
#recomendarModal .modal-content {
  height: 787px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  box-sizing: border-box;
  border: none;
}
.correo-header {
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.correo-icono {
  width: 50px;
  height: 50px;
  margin-bottom: 15px;
}
.correo-form {
  width: 100%;
  max-width: 424px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}
.correo-form input,
.correo-form textarea {
  font-family: "Gotham Book";
  font-size: 15px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.correo-form textarea {
  resize: none;
  height: 70px;
}
.correo-footer {
  margin-bottom: 35px;
  width: 262px;
  height: 45px;
  display: flex;
  justify-content: center;
  gap: 10px;
}
.info-text {
  font-family: "Gotham Book";
  font-size: 15px;
  line-height: 20px;
  color: #5B6670;
  margin: 0;
  align-self: flex-start;
}
.btn-cancelar {
  width: 126px;
  background-color: #FFFFFF;
  font-size: 15px;
  line-height: 100%;
  font-family: "Gotham Medium";
  color: #323E48;
  border-radius: 4px;
  border: 1px solid #323E48;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  text-decoration: none;
  padding: 10px 30px;
}
.btn-enviar {
  width: 126px;
  font-size: 15px;
  line-height: 100%;
  font-family: "Gotham Medium";
  background-color: #EB0029;
  color: #FFFFFF;
  border-radius: 4px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  text-decoration: none;
  padding: 10px 30px;
}
.btn-enviar:hover {
  background-color: #E30028;
}
.btn-enviar:active {
  background-color: #E30028 !important;
  color: #FFFFFF !important;
  box-shadow: inset 0 2px 4px rgba(104, 1, 1, 0.3) !important;
}
.btn-enviar:disabled {
  background-color: #CFD2D3;
  color: #A2A9AD;
  cursor: not-allowed;
}
.btn-cancelar:hover,
.btn-cancelar:active {
  color: #EB0029;
  border-color: #EB0029;
  background-color: white !important;
  box-shadow: none !important;
}
.input-wrapper {
  position: relative;
  height: 71px;
  width: 100%;
}
.custom-input {
  border: none !important;
  background-color: #F4F7F8;
  border-radius: 8px 8px 0 0 !important;
  border-bottom: 1px solid #5B6670 !important;
  width: 100%;
  padding-left: 20px !important;
  padding-right: 20px !important;
  padding-top: 30.5px !important;
  padding-bottom: 1.5px !important;
  font-family: "Gotham Medium" !important;
  color: #323E48;
  font-size: 15px;
  line-height: 18px;
  height: 50px;
}
.custom-textarea {
  border: none !important;
  background-color: #F4F7F8;
  border-radius: 8px 8px 0 0 !important;
  border-bottom: 1px solid #5B6670 !important;
  width: 100%;
  padding-left: 20px !important;
  padding-right: 20px !important;
  padding-top: 25px !important;
  font-family: "Gotham Medium" !important;
  color: #323E48;
  font-size: 15px;
  line-height: 100%;
  height: 70px;
}
.custom-input:focus,
.custom-textarea:focus {
  outline: none !important;
  box-shadow: none !important;
}
.floating-label {
  position: absolute;
  left: 20px;
  top: 14px;
  color: #323E48;
  font-size: 15px;
  line-height: 20px;
  font-family: "Gotham Medium";
  pointer-events: none;
  transition: 0.2s ease all;
}
.input-wrapper input:focus + .floating-label,
.input-wrapper input:not(:placeholder-shown) + .floating-label,
.input-wrapper textarea:focus + .floating-label,
.input-wrapper textarea:not(:placeholder-shown) + .floating-label {
  top: 2.5px;
  font-size: 15px;
  line-height: 20px;
  font-family: "Gotham Book";
  color: #5B6670;
  padding: 0;
}
.text-indicator {
  font-size: 12px;
  line-height: 14px;
  color: #323E48;
  display: flex;
  justify-content: flex-end;
  font-family: "Gotham Book";
}
.modal-static .modal-dialog {
  transform: none !important;
}
.custom-input:-webkit-autofill,
.custom-textarea:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px #F4F7F8 inset !important;
  -webkit-text-fill-color: #323E48 !important;
  transition: background-color 5000s ease-in-out 0s;
}
.custom-input:-webkit-autofill:focus,
.custom-textarea:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0 1000px #F4F7F8 inset !important;
  -webkit-text-fill-color: #323E48 !important;
}
.input-wrapper.error .custom-input {
  border-bottom: 1px solid #EB0029 !important;
}
.input-wrapper.error label.floating-label,
.input-wrapper.error .floating-label,
.input-wrapper.error .floating-label.float {
  color: #EB0029 !important;
}
.input-wrapper.error .floating-label::after {
  color: #EB0029;
}
.helper-error,
.text-danger {
  color: #EB0029;
  font-size: 12px;
  line-height: 14px;
  margin-top: 7px;
  font-family: "Gotham Book";
}
@media (max-width: 450px) {
  .info-text {
    padding: 0 8px;
  }
  .text-indicator {
    padding: 0 4px;
  }
}
@media (max-width: 436px) {
  .btn-detalle {
    padding: 10px 20px;
    gap: 10px;
  }
}
/*# sourceMappingURL=/banorte/__host/inmuebles/Inmuebles/detalle-inmueble.component.css.map */
